import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import { FACTURA, ORDEN_SERVICIO, OTROS } from '../../../common/types/tipoComprobanteType';
import proveedorService from '../../../service/administracion/proveedorService';

import ordenServicioService from '../../../service/logistica/ordenServicioService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModalVer from '../OrdenServicio/FormModalVer';
import ImprimirModal from '../OrdenServicio/ImprimirModal';
import IngresoObservacionModal from './IngresoObservacionModal'

var referenciaCount = 1;


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        debugger
        this.state = {
            loadingSource: true,
            formValues: this.fetchEmptyFormValues(),
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstadoOrdenServicio:0,
                idProveedor:0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleVer: false,
            proveedores: [],
            ingresoObservacionModal: {
                nombre: ''
            },
            imprimirFormValues: {
                file: undefined,
                idOrdenServicio: 0
            }
        }
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, ordenServicioService.paginacion);


        const filter = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID
        }

        const proveedores = await proveedorService.obtenerTodos(filter);

        this.setState({
            loadingSource: false,
             proveedores: proveedores ? proveedores : []
        });
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleKeyUpInputSelect = (e) => {
        debugger
        const filter = { ...this.state.filter, ...FILTER, idEstadoOrdenServicio: e.key };
        this._handlePagination(filter);
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: '',
            idEstadoOrdenServicio:0,
            idProveedor:0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleVer = async (values) => {
        const response = await ordenServicioService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenServicioDetalles.length; i++) {
                var item = response.ordenServicioDetalles[i];
                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenServicioReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenServicioReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues,
            });
        }
    }

    handleRechazar = async (values) => {
        dialog.confirm(`¿Desea rechazar la Orden de Servicio ${values.serie}-${values.documento}?`, async () => {
            debugger
            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                visible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {
        debugger
        var data = {
            idOrdenServicio: values.id,
            codOrdenServicioEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };
        console.log(data);
        var response = await ordenServicioService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ visible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');

    }

    handleAprobar = async (values) => {
        dialog.confirm(`¿Desea aprobar la Orden de Servicio ${values.serie}-${values.documento}?`, async () => {
            debugger
            var data = {
                idOrdenServicio: values.id,
                codOrdenServicioEstado: 'AP'
            };
            var response = await ordenServicioService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            };

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            };

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    fetchEmptyFormValues = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idCliente: 0,
            idEstablecimientoCliente: 0,
            idMoneda: SOLES,
            idListaPrecio: 0,
            idEstablecimiento: 0,
            idProyecto: 0,
            serie: _year,
            documento: "",
            fechaStr: global.fetchCurrentDateStr(),
            fechaVencimientoStr: global.fetchCurrentDateStr(),
            diasVencimiento: 0,
            tipoCambio: 0,
            observacion: "",
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
        }
    };

    fetchEditFormValues = (value) => {

        return {
            id: value.ordenServicio.id,
            idCliente: value.ordenServicio.idEntidadProveedor, //..........................................................OK
            idEstablecimientoCliente: value.ordenServicio.idEstablecimientoProveedor, //..........................................................OK
            idMoneda: value.ordenServicio.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.ordenServicio.idEstablecimiento,
            idProyecto: value.ordenServicio.idProyecto,
            serie: value.ordenServicio.serie, //............................................... OK
            documento: value.ordenServicio.documento, //............................................... OK
            documentoCliente: value.ordenServicio.documentoProveedor,
            fechaStr: value.ordenServicio.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenServicio.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenServicio.diasVencimiento, //..........................................................OK
            tipoCambio: value.ordenServicio.tipoCambio, //..........................................................OK
            observacion: value.ordenServicio.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenServicio.subTotal,
            sumaIgv: value.ordenServicio.igv,
            sumaTotal: value.ordenServicio.total,
            //almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            //vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: [],
            nombreMoneda: value.ordenServicio.nombreMoneda,
            nombreProyecto: value.ordenServicio.nombreProyecto,
            proveedor: value.ordenServicio.proveedor,
            direccionEstablecimiento: value.ordenServicio.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenServicio.nombreEstablecimientoSucursal
        }
    }

    handleExportExcel = async () => {
        var response = await ordenServicioService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de OdenServicio.xlsx");
    }


    handleImprimir = async (item) => {
        
        var file = undefined;
        var response = await ordenServicioService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenServicio: item.id
            }
        });
    };

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenServicio: values.id,
                codOrdenServicioEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenServicioService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Bandeja de Orden de Servicio"
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    entidades={this.state.proveedores}

                    onKeyUpSearch={this.handleKeyUpInput}
                    onKeyUpSearchSelect={this.handleKeyUpInputSelect}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onChange={this._handleChangePagination}
                    onVer={this.handleVer}
                    onRechazar={this.handleRechazar}
                    onAprobar={this.handleAprobar}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <IngresoObservacionModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleCompletarRechazo}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        );
    }
}